import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { COBERTURA_REINCLUIR_MESES } from './coberturaSaldo';

interface AvisoReinclusaoRateioProps {
  /** UCs fora do rateio com saldo para menos de 2 meses. */
  total: number;
  /** Quantas delas já têm pedido "Incluir no rateio" em aberto. */
  pedidas: number;
  /** Quantas estão "Pausada" no cadastro e precisam do "Destravar" de um gestor. */
  pausadas: number;
  onVer: () => void;
}

/**
 * Aviso do topo do painel de Saldos (#6190): UCs que saíram do rateio por ter saldo
 * sobrando e cujo saldo está acabando. É o mesmo corte do alerta da Vick.
 */
const AvisoReinclusaoRateio: React.FC<AvisoReinclusaoRateioProps> = ({ total, pedidas, pausadas, onVer }) => {
  if (total <= 0) return null;
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-4 rounded-2xl bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800/50">
      <div className="flex items-start gap-2 text-sm text-red-800 dark:text-red-300">
        <AlertTriangle size={16} className="flex-shrink-0 mt-0.5" />
        <div>
          <p>
            <strong>{total}</strong> UC(s) fora do rateio com saldo para menos de {COBERTURA_REINCLUIR_MESES} meses.
            Peça a volta delas no próximo envio do rateio: a mudança só vale no ciclo seguinte.
          </p>
          {pedidas > 0 || pausadas > 0 ? (
            <p className="text-xs mt-1 text-red-700/90 dark:text-red-300/90">
              {pedidas > 0 ? `${pedidas} já com pedido "Incluir no rateio" registrado. ` : ''}
              {pausadas > 0
                ? `${pausadas} estão "Pausada" no cadastro: um gestor precisa abrir a UC e usar o "Destravar" antes de a planilha subir, senão o cadastro delas não muda.`
                : ''}
            </p>
          ) : null}
        </div>
      </div>
      <button
        onClick={onVer}
        className="flex-shrink-0 px-3 py-1.5 rounded-lg text-xs font-bold bg-white dark:bg-slate-900 border border-red-200 dark:border-red-800/50 text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/30"
      >
        Ver essas UCs
      </button>
    </div>
  );
};

export default AvisoReinclusaoRateio;
